import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ai-websites-2/artifacts/idq8yn2y_WhatsApp%20Image%202026-03-09%20at%2009.42.59.jpeg";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <header className="border-b border-white/5">
        <div className="max-w-4xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src={LOGO_URL} alt="AG Collective" className="h-7 w-auto invert" />
          </Link>
          <Link 
            to="/" 
            className="flex items-center gap-2 text-sm text-neutral-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver al inicio
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-medium mb-4">Términos de Servicio</h1>
        <p className="text-neutral-500 mb-12">Última actualización: Marzo 2024</p>

        <div className="prose prose-invert prose-neutral max-w-none">
          {/* Introducción */}
          <section className="mb-12">
            <h2 className="text-2xl font-medium mb-4 text-white">1. Aceptación de los Términos</h2>
            <p className="text-neutral-400 leading-relaxed mb-4">
              Al acceder y utilizar los servicios de AG Collective ("la Agencia", "nosotros", "nuestro"), usted acepta estar sujeto a estos Términos de Servicio. Si no está de acuerdo con alguna parte de estos términos, no podrá acceder al servicio.
            </p>
            <p className="text-neutral-400 leading-relaxed">
              Estos términos aplican a todos los visitantes, usuarios y clientes que accedan o utilicen nuestros servicios de marketing digital, incluyendo gestión de redes sociales, publicidad digital, diseño web y automatización.
            </p>
          </section>

          {/* Servicios */}
          <section className="mb-12">
            <h2 className="text-2xl font-medium mb-4 text-white">2. Descripción de los Servicios</h2>
            <p className="text-neutral-400 leading-relaxed mb-4">
              AG Collective ofrece los siguientes servicios de marketing digital:
            </p>
            <ul className="list-disc pl-6 text-neutral-400 space-y-2">
              <li><strong className="text-white">Gestión de Redes Sociales:</strong> Creación y publicación de contenido, gestión de comunidad y estrategia de crecimiento.</li>
              <li><strong className="text-white">Publicidad Digital:</strong> Campañas en Meta Ads (Facebook/Instagram) y Google Ads.</li>
              <li><strong className="text-white">Diseño Web:</strong> Creación de sitios web y landing pages optimizados para conversión.</li>
              <li><strong className="text-white">Automatización con IA:</strong> Implementación de chatbots, funnels automatizados y procesos inteligentes.</li>
            </ul>
          </section>

          {/* Planes y Pagos */}
          <section className="mb-12">
            <h2 className="text-2xl font-medium mb-4 text-white">3. Planes y Pagos</h2>
            <p className="text-neutral-400 leading-relaxed mb-4">
              Ofrecemos tres planes de suscripción mensual:
            </p>
            <ul className="list-disc pl-6 text-neutral-400 space-y-2 mb-4">
              <li><strong className="text-white">Plan START:</strong> $300 USD/mes</li>
              <li><strong className="text-white">Plan GROWTH:</strong> $600 USD/mes</li>
              <li><strong className="text-white">Plan ELITE:</strong> $1,200 USD/mes</li>
            </ul>
            <p className="text-neutral-400 leading-relaxed mb-4">
              <strong className="text-white">Facturación:</strong> Los pagos se procesan mensualmente a través de Stripe o criptomonedas. La suscripción se renueva automáticamente cada mes hasta que sea cancelada.
            </p>
            <p className="text-neutral-400 leading-relaxed mb-4">
              <strong className="text-white">Reembolsos:</strong> No ofrecemos reembolsos por servicios ya prestados. Si cancela su suscripción, continuará teniendo acceso a los servicios hasta el final del período de facturación actual.
            </p>
            <p className="text-neutral-400 leading-relaxed">
              <strong className="text-white">Cambios de precio:</strong> Nos reservamos el derecho de modificar nuestros precios. Cualquier cambio será notificado con 30 días de anticipación.
            </p>
          </section>

          {/* Obligaciones del Cliente */}
          <section className="mb-12">
            <h2 className="text-2xl font-medium mb-4 text-white">4. Obligaciones del Cliente</h2>
            <p className="text-neutral-400 leading-relaxed mb-4">
              Al contratar nuestros servicios, usted se compromete a:
            </p>
            <ul className="list-disc pl-6 text-neutral-400 space-y-2">
              <li>Proporcionar información veraz y actualizada sobre su negocio.</li>
              <li>Otorgar los accesos necesarios a sus cuentas de redes sociales y plataformas publicitarias.</li>
              <li>Aprobar el contenido y las campañas en los plazos acordados.</li>
              <li>Realizar los pagos de manera puntual según el plan contratado.</li>
              <li>No utilizar nuestros servicios para actividades ilegales o que violen los términos de las plataformas de terceros.</li>
              <li>Mantener la confidencialidad de las estrategias y materiales compartidos.</li>
            </ul>
          </section>

          {/* Obligaciones de la Agencia */}
          <section className="mb-12">
            <h2 className="text-2xl font-medium mb-4 text-white">5. Obligaciones de AG Collective</h2>
            <p className="text-neutral-400 leading-relaxed mb-4">
              Nos comprometemos a:
            </p>
            <ul className="list-disc pl-6 text-neutral-400 space-y-2">
              <li>Ejecutar los servicios contratados con profesionalismo y diligencia.</li>
              <li>Entregar reportes periódicos sobre el desempeño de las campañas.</li>
              <li>Mantener la confidencialidad de la información de su negocio.</li>
              <li>Comunicar de manera oportuna cualquier situación que afecte el servicio.</li>
              <li>Cumplir con las políticas y términos de las plataformas de terceros (Meta, Google, etc.).</li>
            </ul>
          </section>

          {/* Propiedad Intelectual */}
          <section className="mb-12">
            <h2 className="text-2xl font-medium mb-4 text-white">6. Propiedad Intelectual</h2>
            <p className="text-neutral-400 leading-relaxed mb-4">
              <strong className="text-white">Contenido creado:</strong> Todo el contenido creado específicamente para su marca (imágenes, textos, videos) será de su propiedad una vez completado el pago correspondiente.
            </p>
            <p className="text-neutral-400 leading-relaxed mb-4">
              <strong className="text-white">Metodologías y herramientas:</strong> Las metodologías, estrategias, templates y herramientas desarrolladas por AG Collective permanecen siendo propiedad intelectual de la agencia.
            </p>
            <p className="text-neutral-400 leading-relaxed">
              <strong className="text-white">Portfolio:</strong> Nos reservamos el derecho de utilizar el trabajo realizado para su marca en nuestro portfolio y materiales de marketing, a menos que se acuerde lo contrario por escrito.
            </p>
          </section>

          {/* Limitación de Responsabilidad */}
          <section className="mb-12">
            <h2 className="text-2xl font-medium mb-4 text-white">7. Limitación de Responsabilidad</h2>
            <p className="text-neutral-400 leading-relaxed mb-4">
              AG Collective no garantiza resultados específicos en términos de ventas, leads o engagement, ya que estos dependen de múltiples factores fuera de nuestro control.
            </p>
            <p className="text-neutral-400 leading-relaxed mb-4">
              No seremos responsables por:
            </p>
            <ul className="list-disc pl-6 text-neutral-400 space-y-2">
              <li>Cambios en las políticas o algoritmos de plataformas de terceros (Meta, Google, etc.).</li>
              <li>Suspensión o cierre de cuentas por violaciones a términos de terceros no causadas por nosotros.</li>
              <li>Pérdidas indirectas, consecuentes o incidentales.</li>
              <li>Retrasos causados por falta de respuesta o aprobación del cliente.</li>
            </ul>
            <p className="text-neutral-400 leading-relaxed mt-4">
              Nuestra responsabilidad máxima estará limitada al monto pagado por el cliente en los últimos 3 meses de servicio.
            </p>
          </section>

          {/* Cancelación */}
          <section className="mb-12">
            <h2 className="text-2xl font-medium mb-4 text-white">8. Cancelación del Servicio</h2>
            <p className="text-neutral-400 leading-relaxed mb-4">
              <strong className="text-white">Por el cliente:</strong> Puede cancelar su suscripción en cualquier momento notificando con al menos 15 días de anticipación al final del período de facturación actual.
            </p>
            <p className="text-neutral-400 leading-relaxed mb-4">
              <strong className="text-white">Por AG Collective:</strong> Nos reservamos el derecho de terminar el servicio con 30 días de anticipación o de manera inmediata en caso de:
            </p>
            <ul className="list-disc pl-6 text-neutral-400 space-y-2">
              <li>Falta de pago por más de 15 días.</li>
              <li>Violación de estos términos de servicio.</li>
              <li>Conducta que perjudique nuestra reputación o la de terceros.</li>
              <li>Solicitud de actividades ilegales o no éticas.</li>
            </ul>
          </section>

          {/* Confidencialidad */}
          <section className="mb-12">
            <h2 className="text-2xl font-medium mb-4 text-white">9. Confidencialidad</h2>
            <p className="text-neutral-400 leading-relaxed">
              Ambas partes acuerdan mantener la confidencialidad de toda la información sensible compartida durante la relación comercial. Esto incluye estrategias de negocio, datos financieros, información de clientes y cualquier otro material marcado como confidencial. Esta obligación permanece vigente incluso después de la terminación del servicio.
            </p>
          </section>

          {/* Ley Aplicable */}
          <section className="mb-12">
            <h2 className="text-2xl font-medium mb-4 text-white">10. Ley Aplicable y Jurisdicción</h2>
            <p className="text-neutral-400 leading-relaxed">
              Estos términos se regirán e interpretarán de acuerdo con las leyes de los Estados Unidos Mexicanos. Cualquier disputa que surja en relación con estos términos estará sujeta a la jurisdicción exclusiva de los tribunales de la Ciudad de México. Las partes acuerdan intentar resolver cualquier disputa de manera amistosa antes de recurrir a acciones legales.
            </p>
          </section>

          {/* Modificaciones */}
          <section className="mb-12">
            <h2 className="text-2xl font-medium mb-4 text-white">11. Modificaciones</h2>
            <p className="text-neutral-400 leading-relaxed">
              Nos reservamos el derecho de modificar estos términos en cualquier momento. Los cambios entrarán en vigor 30 días después de su publicación en nuestro sitio web. El uso continuado de nuestros servicios después de cualquier modificación constituye su aceptación de los nuevos términos.
            </p>
          </section>

          {/* Contacto */}
          <section className="mb-12">
            <h2 className="text-2xl font-medium mb-4 text-white">12. Contacto</h2>
            <p className="text-neutral-400 leading-relaxed mb-4">
              Si tiene preguntas sobre estos términos de servicio, contáctenos:
            </p>
            <div className="bg-neutral-900/50 border border-white/5 rounded-xl p-6">
              <p className="text-white font-medium mb-2">AG Collective</p>
              <p className="text-neutral-400">Email: hola@agcollective.co</p>
              <p className="text-neutral-400">WhatsApp: +57 300 123 4567</p>
              <p className="text-neutral-400">Ubicación: Ciudad de México, México</p>
            </div>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/5 py-8">
        <div className="max-w-4xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-neutral-600">© 2024 AG Collective. Todos los derechos reservados.</p>
          <div className="flex gap-6 text-sm text-neutral-600">
            <Link to="/privacy" className="hover:text-white transition-colors" data-testid="terms-footer-privacy">Política de privacidad</Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-testid="terms-footer-terms">Términos de servicio</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
